import * as React from 'react';
import {
  ImageStyle,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import dateformat from 'dateformat';

import FastImageAdapter from '../../../shared/fast_image/FastImageAdapter';
import MoreIcon from '../../../shared/icons/ionicons/MoreIcon';

import StoryCoverImageDecorator from '../../../../view_models/StoryCoverImageDecorator';

import {colors} from '../../../../styles/variables';
import {storyCoverImageUrl} from '../../../../helpers/images';

import EpisodeVideoExportJobExecution from '../../../../../domain/entities/writer/EpisodeVideoExportJobExecution';

interface Props {
  episodeVideoExportJobExecution: EpisodeVideoExportJobExecution;
  onSelectEpisodeVideoExportJobExecution: (
    episodeVideoExportJobExecution: EpisodeVideoExportJobExecution,
  ) => void;
  onOpenActionSheet?: (
    episodeVideoExportJobExecution: EpisodeVideoExportJobExecution,
  ) => void;
}

const EpisodeVideoExportJobExecutionListItem: React.FunctionComponent<
  Props
> = props => {
  const {
    episodeVideoExportJobExecution,
    onSelectEpisodeVideoExportJobExecution,
    onOpenActionSheet,
  } = props;
  const source = React.useMemo(() => {
    return {
      uri: storyCoverImageUrl(
        new StoryCoverImageDecorator(
          episodeVideoExportJobExecution.episode.story,
        ),
        'small',
      ),
      headers: {Accept: 'image/webp,image/apng,*/*'},
    };
  }, []);
  const onPress = React.useCallback(() => {
    onSelectEpisodeVideoExportJobExecution(episodeVideoExportJobExecution);
  }, []);
  const handleOpenActionSheet = React.useCallback(() => {
    onOpenActionSheet && onOpenActionSheet(episodeVideoExportJobExecution);
  }, []);
  return (
    <Pressable
      style={styles.container}
      disabled={episodeVideoExportJobExecution.status !== 'succeeded'}
      onPress={onPress}>
      {episodeVideoExportJobExecution.episode.story.hasCoverImage ? (
        <FastImageAdapter style={styles.image} source={source} />
      ) : (
        <View style={styles.image}>
          <Text style={styles.noImageText}>表紙なし</Text>
        </View>
      )}
      <View style={styles.storyInfo}>
        <Text style={styles.title}>
          {episodeVideoExportJobExecution.episode.story.title}
        </Text>
        {episodeVideoExportJobExecution.status === 'succeeded' &&
        episodeVideoExportJobExecution.finishedAt ? (
          <Text style={styles.createdAt}>
            {dateformat(
              episodeVideoExportJobExecution.finishedAt,
              'yyyy.mm.dd',
            )}{' '}
            作成
          </Text>
        ) : (
          <Text style={styles.label}>作成中</Text>
        )}
      </View>
      <View>
        {onOpenActionSheet && (
          <Pressable
            style={Platform.select({
              web: {pointerEvents: 'all'} as any,
              default: {},
            })}
            onPress={handleOpenActionSheet}>
            <MoreIcon />
          </Pressable>
        )}
      </View>
    </Pressable>
  );
};

export default React.memo(EpisodeVideoExportJobExecutionListItem);

const ASPECT_RATIO = 0.56;
const width = 70;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 10,
    backgroundColor: 'white',
  } as ViewStyle,
  image: {
    alignItems: 'center',
    alignSelf: 'stretch',
    aspectRatio: ASPECT_RATIO,
    backgroundColor: colors.powderGray,
    justifyContent: 'center',
    width,
    height: width / ASPECT_RATIO,
  } as ImageStyle,
  noImageText: {
    color: colors.lightGray,
    fontSize: 10,
  } as TextStyle,
  storyInfo: {
    flex: 1,
    margin: 10,
  } as ViewStyle,
  title: {
    color: '#222',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  } as TextStyle,
  createdAt: {
    color: '#666',
    fontSize: 10,
  } as TextStyle,
  label: {
    borderColor: '#2c86d7',
    borderWidth: 1,
    color: '#2c86d7',
    fontSize: 8,
    justifyContent: 'center',
    textAlign: 'center',
    width: 36,
  } as TextStyle,
});
